// 产品资料模块的状态文案与颜色（文档 18 §4：5 色 + 灰；一行只允许一个实底标签）。
import type { TagTone } from '@/lib/status';

/** 套装用量模式：按组计的组件用蓝底，与按套计的灰底区分（文档 23 §11「每组用量 ≠ 每套用量」） */
export const quantityMode: Record<string, { label: string; tone: TagTone }> = {
  PER_SET: { label: '按套', tone: 'none' },
  PER_GROUP: { label: '按组', tone: 'blue' },
};

/** 套装启用状态：启用是常态不打标签，只有停用给灰标签 */
export function bundleState(isActive: boolean) {
  return isActive ? null : { label: '停用', tone: 'none' as TagTone };
}

/** 包装方案：默认方案 / 默认报价 */
export const defaultMark = { label: '默认', tone: 'blue' as TagTone };

/** 图片类型（老系统 ProductImageType） */
export const imageType: Record<string, string> = {
  COVER: '主图',
  SCENE: '场景图',
  GALLERY: '图片',
};

/** 报价历史来源（src/lib/quote-history.ts 的 source） */
export const quoteSource: Record<string, string> = {
  'product.create': '新建产品',
  'product.update': '修改产品',
  'product.save': '保存产品',
};

/** 可用库存：可以为负，负数红字、不拦（文档 23 §11） */
export function availClass(n: number) {
  return n < 0 ? 'neg' : '';
}
